module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// /Users/apercu/git/ashlar/statics/domains/node_modules/axios/index.js
// module id = 38
// module chunks = 2